function escapeRegExp(text: string): string {
	return text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
}

/** Lowercase words of a name, with emoji and stray punctuation dropped: "🐞 Bug" is "bug". */
export function nameWords(name: string): string[] {
	return name
		.toLowerCase()
		.replace(/[^\p{L}\p{N}\s&+'/-]/gu, " ")
		.split(/\s+/)
		.filter(Boolean)
}

/**
 * Whole-word, case-insensitive pattern for a name or phrase. A plural on the
 * last word counts both ways, so "Bug" finds "bugs", "Integrations" finds
 * "integration" and "Rechnung" finds "Rechnungen". Words may be joined by
 * spaces, hyphens or underscores. Null for names under two letters.
 */
export function wholeWordPattern(name: string): RegExp | null {
	const words = nameWords(name)
	if (words.join("").replace(/[^\p{L}\p{N}]/gu, "").length < 2) return null

	const last = words.at(-1)!
	const lastBase =
		last.length > 3 && last.endsWith("s") && !last.endsWith("ss")
			? last.slice(0, -1)
			: last
	const body = [
		...words.slice(0, -1).map(escapeRegExp),
		`${escapeRegExp(lastBase)}(?:e?s|e?n)?`,
	].join("[\\s_-]+")
	return new RegExp(`(?<![\\p{L}\\p{N}])${body}(?![\\p{L}\\p{N}])`, "iu")
}
